import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { AxiosInstance, AxiosPromise } from 'axios';
import {
  SearchTerminalAssignmentsRequest,
  SearchTerminalAssignmentsResponse,
  GetTerminalAssignmentRequest,
  GetTerminalAssignmentResponse,
  CreateTerminalAssignmentRequest,
  CreateTerminalAssignmentResponse,
  UpdateTerminalAssignmentRequest,
  UpdateTerminalAssignmentResponse,
  DeleteTerminalAssignmentRequest,
  DeleteTerminalAssignmentResponse,
} from './TerminalAssignmentService.types';

export class TerminalAssignmentService implements BaseRequestEndpoints {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: SearchTerminalAssignmentsRequest) {
    return this.instance.get<SearchTerminalAssignmentsResponse>('/terminal-assignments', {
      params: request.queryParams,
    });
  }

  getById(request: GetTerminalAssignmentRequest) {
    return this.instance.get<GetTerminalAssignmentResponse>(
      `/terminal-assignments/${request.routeParams.id}`,
    );
  }

  create(request: CreateTerminalAssignmentRequest) {
    return this.instance.post<CreateTerminalAssignmentResponse>(
      '/terminal-assignments',
      request.body,
    );
  }

  update(request: UpdateTerminalAssignmentRequest) {
    return this.instance.patch<UpdateTerminalAssignmentResponse>(
      `/terminal-assignments/${request.routeParams.id}`,
      request.body,
    );
  }

  delete(request: DeleteTerminalAssignmentRequest): AxiosPromise<DeleteTerminalAssignmentResponse> {
    return this.instance.delete(`/terminal-assignments/${request.routeParams.id}`);
  }
}
